import { Injectable, inject } from "@angular/core";
import { ApiService } from "app/core/api/api.service";
import { Observable } from "rxjs";
import { CourtOccupancyResponse } from "./court-occupancy.types";

@Injectable({ providedIn: "root" })
export class CourtOccupancyService {
  private readonly _apiService = inject(ApiService);

  getCourtOccupancy(days = 7): Observable<CourtOccupancyResponse> {
    return this._apiService.post<CourtOccupancyResponse>(
      "booking/charts/court-occupancy",
      { days },
    );
  }
}
